// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Moves } from '@gql/base-types';

import { Chip } from '@mui/material';
import { BiSolidArrowFromBottom, BiSolidCar, BiSolidKey, BiUndo } from 'react-icons/bi';

// TYPES ---------------------------------------------------------------------- //

interface MoveTypeBadgeProps {
  move?: Moves;
}

// COMPONENT ------------------------------------------------------------------ //

const MoveTypeBadge = ({ move }: MoveTypeBadgeProps) => {
  if (!move) return null;

  const getType = (move: Moves) => {
    const { consumer_type } = move;

    if (consumer_type === 'customer' && move?.consumer_at_pickup === 1) return 'Pickup';
    if (consumer_type === 'customer' && move?.consumer_at_pickup === 0) return 'Return';
    if (consumer_type === 'loaner') return 'Loaner';
    return 'Operational';
  };

  const getVariant = (type: string) => {
    if (type === 'Pickup') return 'filled';
    if (type === 'Return') return 'filled';
    if (type === 'Loaner') return 'outlined';
    return 'filled';
  };

  const getColor = (type: string) => {
    if (type === 'Pickup') return 'secondary';
    if (type === 'Return') return 'secondary';
    if (type === 'Loaner') return 'secondary';
    return 'default';
  };

  const getIcon = (type: string) => {
    if (type === 'Pickup') return <BiSolidArrowFromBottom size={16} />;
    if (type === 'Return') return <BiUndo size={16} />;
    if (type === 'Loaner') return <BiSolidKey size={16} />;
    return <BiSolidCar size={16} />;
  };

  const type = getType(move);
  const variant = getVariant(type);
  const color = getColor(type);
  const icon = getIcon(type);

  return <Chip variant={variant} color={color} icon={icon} label={type} sx={{ fontWeight: 'bold' }} />;
};

export default MoveTypeBadge;
